import React from 'react'

const PageMain = ({
    className,
    header,
    children,
    footer
}) => (
    <div className={className}>
        {header}

        <div className="jm-page-main">
            {children}
        </div>

        {footer}
    </div>
)

export default PageMain